import React from 'react';
import Modal from 'react-modal';
import SupportCardLevelForm from '../account/forms/supportCardLevelForm.jsx';
import { currencyFormatter } from '../../utils/display';

export default ({
  open, closeSupportCardLevelModal, customerInfo, orderId, orderSupportInfoCommon,
  orderAssistance, formData, setClaimType, setClaimAmountToRefund, sendSupportMessage, sendClaim
}) =>
    <Modal
      className="Modal__Bootstrap modal-dialog"
      closeTimeoutMS={150}
      isOpen={open}
      contentLabel="Support"
    >
      <div className="modal-content modal-content-padding">
        <div className="modal-header mar-t-5">
          <div className="acct-modal-close-btn">
            <i className='fa fa-times' aria-hidden="true" onClick={closeSupportCardLevelModal}></i>
          </div>
          <div className="acct-modal-heading">Order Support</div>
          <div className="acct-modal-hr"></div>
        </div>
        <div className="modal-body modal-body-padding" style={{fontSize: "14px"}}>
          <div><strong>Name: </strong>{ `${customerInfo.get('firstname')} ${customerInfo.get('lastname')}` }</div>
          <div><strong>Order ID: </strong>{ `${orderId}` }</div>
          <div><strong>Merchant: </strong>{ `${orderAssistance.get('merchantName')}` }</div>
          <div><strong>Face Value: </strong>{ `${currencyFormatter(orderAssistance.get('faceValue'))}` }</div>
          <div className="mar-b-15"><strong>Email: </strong>{ `${customerInfo.get('email')}` }</div>
          <div>
            <SupportCardLevelForm
              closeSupportCardLevelModal={closeSupportCardLevelModal}
              formData={formData}
              orderAssistance={orderAssistance}
              orderSupportInfoCommon={orderSupportInfoCommon}
              setClaimType={setClaimType}
              setClaimAmountToRefund={setClaimAmountToRefund}
              sendSupportMessage={sendSupportMessage}
              sendClaim={sendClaim}
            />
          </div>
        </div>
      </div>
    </Modal>
